import React, { Component } from 'react';
import EffectParameterSlider from './EffectParameterSlider.js';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import Dropdown from 'react-dropdown';

class GateEffect extends Component {
    constructor(props) {
        super(props);
    }

    handleOptionChange(trackNumber) {
        this.props.effect.setSideChainedTrack(this.props.tracks[trackNumber], trackNumber);
    }

    getSideChainedTrack() {
        let track = this.props.effect.connectedTrack;
        if (track === undefined) {
            return 0;
        }

        return (this.props.tracks.indexOf(track)) + 1;
    }

    getOptions() {
        return this.props.sequencerEngine.tracks.map(
            track =>
                ({label: "Track " + (track.trackNumber + 1),
                  value: track.trackNumber}));
    }

    getOption(track) {
        if (track === undefined) {
            return undefined;
        }
        return this.getOptions()
            .filter(x => x.value === track.trackNumber)[0];
    }

    render() {
        let className = this.props.automation !== undefined ?
            'enabled effect effect-automation' :
            this.props.effect.isEnabled() ? 'effect enabled' :
            'effect disabled';
        return (
            <div>
              {!this.props.effect.isEnabled() ? '' :
              <div>
                    <div className="sidechain-container">
                <div className="parameter-label">Sidechain: </div>
                    <Dropdown
                          className='osc-type-dropdown'
                          controlClassName='osc-type-control-dropdown'
                          arrowClassName='osc-type-arrow-dropdown'
                          options={this.getOptions()}
                          onChange={(o) => this.handleOptionChange(o.value)}
                          value={this.getOption(this.props.effect.connectedTrack)}
                          placeholder="None" />
                        </div>
                    <div className="clear-fix"/>
                        <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='Smoothing'
                        sequencerEngine={this.props.sequencerEngine}
                        lfoEnabled={true}
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.props.effect.smoothingParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                        step={0.0001}
                        max={2}
                        min={0.00001}
                        />
                        <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='Threshold'
                        sequencerEngine={this.props.sequencerEngine}
                        lfoEnabled={true}
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.props.effect.thresholdParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                        step={0.01}
                        max={6}
                        min={-120}
                        />
 
           </div>}
            </div>
        );
    }
}

export default GateEffect;
